// extracted by mini-css-extract-plugin
export default {"link":"Button_link__xIHN0","primary":"Button_primary__VIPCG","outlined":"Button_outlined__hmXsy","group":"Button_group__9acUu"};